module.exports = __webpack_public_path__ + "d664201f/img/product-icon-grey.b248963c.svg";